module.exports = __webpack_public_path__ + "static/media/dustbin-alt.56488a1b.svg";